import {defineQuery} from 'next-sanity';
import type {FormPricesSchema} from 'schema/singletons/form-prices';

export const FORM_PRICES_QUERY = defineQuery(`
	*[_type == "formPrices"][0]{
		...,
	}
`);

export type FormPricesQueryResult = FormPricesSchema | null;
